import React, { useEffect } from "react";
import Layout from "../components/ui/Layout";
import { motion } from "framer-motion";

const lifeNotes = [
  {
    date: "Mar 5, 2026",
    text: "Young in the crazy AI world. Traditional UI/UX design is dead. Be bold, be vulnerable, be human.",
  },
  {
    date: "Dec 1, 2025",
    text: "youngdesign.pro was born.",
  },
  {
    date: "Feb, 2022",
    text: "Made my first website using WIX.",
  },
  {
    date: "Jan 28, 2021",
    text: "Young landed in YVR with 3 luggage bags, and a curious heart.",
  },
  {
    date: "Nov 9, 1995",
    text: "Young was born in Zhejiang, China. Welcome myself to this live game show.",
  },
];

const RandomLifeNotes = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Layout>
      <section className="py-12 sm:py-16 md:py-24 bg-black text-white min-h-screen">
        <div className="max-w-2xl mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
          <motion.h1
            className="text-2xl md:text-3xl font-light text-white mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Life Notes
          </motion.h1>

          <motion.div
            className="space-y-12"
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
          >
            {lifeNotes.map((note, index) => (
              <motion.div
                key={index}
                className="border-l-2 border-gray-600 pl-6 py-2"
                variants={fadeInUp}
                transition={{ duration: 0.5 }}
              >
                <p className="text-sm text-gray-400 mb-2">{note.date}</p>
                <p className="text-lg leading-relaxed text-gray-200">
                  {note.text}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default RandomLifeNotes;
